import { LazyLoadBackgroundImage } from '@tjoskar/react-lazyload-img';
import React from 'react';
import { useTranslation } from 'react-i18next';

import './post-media.scss';
import { PostMedia } from '@/types/post';
import FallbackImage from '@/assets/fallback.png';
import { FileResource } from '@/component/Resource/FileResource';

export const PostMediaContent = ({ media }: { media?: PostMedia }): JSX.Element => {
  const { t } = useTranslation('common');
  return (
    <div style={{ marginBottom: 10 }}>
      {media?.type === 'resource' && (
        <FileResource
          resource={{
            fileUrl: media.url,
            name: media.url.split('/').pop()?.split('.').pop()?.toUpperCase(),
            description: media.url.split('/').pop(),
          }}
        />
      )}
      {media?.type === 'image' && (
        <LazyLoadBackgroundImage className="is-relative post-image" defaultImage={FallbackImage} image={media.url} />
      )}
      {media?.type === 'video' && (
        <div className="video-container">
          <iframe className="video" src={media.url} allowFullScreen title={t('Video')} />
        </div>
      )}
    </div>
  );
};
